/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Fragment, PureComponent } from 'react';
import { uuid } from '@carvana/purchase-utils';
import ExperimentContext from '../experiment/provider';

const divStyle = {
  border: '5px solid pink',
  display: 'inline-block',
  padding: '0px 15px 5px',
  borderRadius: '20px 0 0 2px',
  borderStyle: 'solid',
  borderWidth: '1px 0 0 1px',
  cursor: 'help',
  zIndex: '1000000000000',
  backgroundColor: 'rgba(255, 255, 255, 0.6)',
  textAlign: 'left',
  maxHeight: '100%',
  overflow: 'auto',
  position: 'relative',
};

const experimentGroup = {
  borderBottom: 'solid 1px black',
  paddingTop: '15px'
};

const radioWidthOverride = {
  width: '1em',
  clip: 'inherit',
  height: '1em',
  position: 'inherit'
};

export default class Debugger extends PureComponent {
  static contextType = ExperimentContext;

  state = {
    showExperiments: false
  };

  showHideExperiments = () => {
    this.setState(state => ({
      showExperiments: !state.showExperiments
    }));
  };

  updateBucket = (experimentName, bucketName) => {
    const { context: { UpdateAssignedBucketByExperimentName } = {} } = this;

    UpdateAssignedBucketByExperimentName({ bucketName, experimentName });
  };

  render() {
    const { context: { experiments } = {} } = this;
    const { showExperiments } = this.state;
    const isProduction = process.env.NODE_ENV === 'production';
    const hasExperiments = Object.keys(experiments).length > 0;

    return (
      !isProduction &&
      hasExperiments && (
        <div style={divStyle}>
          <p style={{ textAlign: 'center' }} onClick={this.showHideExperiments}>
            Experiments
          </p>
          {showExperiments && (
            <Fragment>
              {Object.keys(experiments).map(experimentName => (
                <div key={experimentName} style={experimentGroup}>
                  <b>{experimentName}</b>
                  {(experiments[experimentName].buckets || [])
                    .sort()
                    .map(bucket => {
                      const id = uuid();
                      return (
                        <div key={id}>
                          <label htmlFor={id}>
                            <input
                              style={radioWidthOverride}
                              type="radio"
                              name={id}
                              id={id}
                              value={bucket}
                              onChange={() =>
                                this.updateBucket(experimentName, bucket)
                              }
                              checked={
                                bucket ===
                                experiments[experimentName].assignedBucket
                              }
                            />
                            {bucket}
                          </label>
                        </div>
                      );
                    })}
                </div>
              ))}
            </Fragment>
          )}
        </div>
      )
    );
  }
}
